export function disableBodyScroll(): void {
  const scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.overflow = "hidden";
  document.body.style.height = "100vh";
  document.body.style.top = `-${scrollY}px`;
}

export function allowBodyScroll(): void {
  const scrollY = -parseInt(document.body.style.top || "0");
  document.body.style.position = "";
  document.body.style.overflow = "";
  document.body.style.top = "";
  document.body.style.height = "auto";
  scrollTo(0, scrollY);
}
